<template>
  <default>
    <h2>Projekty</h2>
    <br>
    <div @click="selectProject(project)"
         v-for="project in store.selectedSpace.projects"
         class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">
      {{ project.name }}
    </div>
  </default>
</template>

<script>
import Default from "@/layouts/admin/default.vue";
import {useAppStore} from "@/stores/appStore"

export default {
  name: "ProjectView",
  components: {Default},
  data() {
    return {
      store: useAppStore()
    }
  },
  methods: {
    selectProject(project) {
      this.store.selectedProject = project;
      this.$router.push('/' +
          this.store.toUrl(this.store.selectedProject.spaceName) + '/' +
          this.store.toUrl(this.store.selectedProject.name) +
          "/pages"
      );
    }
  }
}
</script>

<style scoped>

</style>